import type {FC, JSX} from 'react';

import * as S from './styles';

type PropsType = {
  children?: JSX.Element;
  icon: FC;
  isActive: boolean;
  isCoach: boolean;
  label: string;
  showBadge?: boolean;
};

export const MainMenuItem: FC<PropsType> = ({
  children,
  icon,
  isActive,
  isCoach,
  label,
  showBadge,
}) => {
  return (
    <S.Container isActive={isActive} isCoach={isCoach} showBadge={showBadge}>
      <S.Icon $isActive={isActive} $isCoach={isCoach} component={icon} />
      <S.Label isActive={isActive}>{label}</S.Label>
      <S.ChildContainer>{children}</S.ChildContainer>
    </S.Container>
  );
};
